import * as React from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Field, change, formValueSelector } from 'redux-form';
import { find, isEmpty } from 'lodash';
import KeyboardArrowRight from 'material-ui/svg-icons/hardware/keyboard-arrow-right';
import KeyboardArrowLeft from 'material-ui/svg-icons/hardware/keyboard-arrow-left';
import { fetch } from '@utils/utils';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import RemoteGrid from '@inqool/uas-web-core/es/components/controls/RemoteGrid';

import * as T from '@components/form/TransferGrid/_transferGridTypes';
import { InlineGridField, InlineGrid } from '@components/form';

const getParams = ({ sort, order, pageSize, page, filters, universalFilter, query, allowDeleted, doPost }) => {
  const filterClean = filters
    .filter(({ field }) => field !== null)
    .filter(({ operation }) => operation !== null)
    .filter(({ value, filter: f }) => (value !== null && value !== '' && value !== undefined) || f);
  let filter = null;
  if (doPost) {
    filter = filterClean;
  } else {
    filter = filterClean.reduce(
      (acc, { field, operation, value }, i) => ({
        ...acc,
        [`filter[${i}].field`]: field,
        [`filter[${i}].operation`]: operation,
        [`filter[${i}].value`]: value
      }),
      {}
    );
  }

  let constructedUniversalFilter = {};
  if (universalFilter) {
    constructedUniversalFilter = doPost
      ? { universalFilter: { value: universalFilter } }
      : { 'universalFilter.value': universalFilter };
  }

  const constructedSort = sort ? { sort, order } : undefined;

  return {
    pageSize,
    page,
    ...constructedSort,
    ...query,
    ...(doPost ? { filter } : filter),
    ...constructedUniversalFilter,
    allowDeleted: !!allowDeleted
  };
};

const getItems = async (url, { doPost, ...props }: any) => {
  if (doPost) {
    const params = getParams({ ...props, doPost });
    const response = await fetch(`${url}/parametrized`, {
      method: 'POST',
      headers: new Headers({ 'Content-Type': 'application/json' }),
      body: JSON.stringify(params)
    });
    return await response.json();
  } else {
    const response = await fetch(url);
    return await response.json();
  }
};

const enhance = compose<any, any>(
  connect(
    (state, { meta, input: { name } }: T.OutterProps & T.InnerProps) => {
      return {
        items: formValueSelector(meta.form)(state, name) || []
      };
    },
    (dispatch, { meta }: T.OutterProps) => ({
      changeForm: (name: string, value: any) => dispatch(change(meta.form, name, value))
    })
  )
);

const TransferGrid: React.SFC<T.OutterProps & T.InnerProps> = ({
  input: { name },
  items,
  changeForm,
  columns,
  url,
  doPost,
  filters = []
}) => {
  const gridProps = {
    adding: false,
    filtering: false,
    showCheckboxes: true,
    columns
  };
  const key = JSON.stringify(items);
  return (
    <div className="transfer-grid">
      <RemoteGrid
        {...{
          ...gridProps,
          key: `${key}-1`,
          url,
          doPost,
          getItems,
          filters: [...filters, ...items.map(({ id }) => ({ field: 'id', operation: 'NEQ', value: id }))],
          ActionBar: ({ checkedItems }) => (
            <div style={{ marginLeft: -2, marginTop: 10, display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
              <Button
                icon={<KeyboardArrowRight />}
                onClick={() => {
                  changeForm(name, [...items, ...checkedItems]);
                }}
                disabled={isEmpty(checkedItems)}
              />
            </div>
          ),
          pageSizeItems: [
            { id: 10, label: '10' },
            { id: 15, label: '15' },
            { id: 20, label: '20' },
            { id: 50, label: '50' },
            { id: 100, label: '100' },
            { id: 200, label: '200' }
          ],
          pageSize: 15,
          sort: 'name',
          order: 'ASC'
        }}
      />
      <div style={{ width: 10 }} />
      <InlineGridField
        {...{
          ...gridProps,
          key: `${key}-2`,
          component: InlineGrid,
          name,
          ActionBar: ({ items: gridItems, checkedItems }) => (
            <div style={{ marginLeft: -4, marginTop: 10, display: 'flex' }}>
              <Button
                icon={<KeyboardArrowLeft />}
                onClick={() => {
                  changeForm(name, gridItems.filter(({ id }) => !find(checkedItems, item => item.id === id)));
                }}
                disabled={isEmpty(checkedItems)}
              />
            </div>
          )
        }}
      />
    </div>
  );
};

export default enhance(TransferGrid);

export class TransferGridField extends Field<T.OutterCustomProps> {}



// WEBPACK FOOTER //
// ./src/components/form/TransferGrid/TransferGrid.tsx